<script lang="ts" setup>
import { usePage } from "@inertiajs/vue3";
import { computed, ref } from "vue";

const props = defineProps<{
    skillId: 1 | 2 | 3;
    active?: boolean;
    votes: number;
    totalVotes: number;
}>();

const page = usePage();

const name = computed(() => {
    switch (props.skillId) {
        case 1:
            return "Combo Attack";
        case 2:
            return "Critical Hit";
        case 3:
            return "Evasion";
    }
});

const percentage = computed(() => {
    return props.totalVotes === 0 || props.votes === 0
        ? 0
        : (props.votes / props.totalVotes) * 100;
});

const percentageClass = computed(() => {
    if (percentage.value >= 67) {
        return "text-green-300";
    }

    if (percentage.value >= 33) {
        return "text-yellow-300";
    }

    return "text-red-300";
});

const hover = ref(false);
</script>

<template>
    <div
        class="flex cursor-pointer items-center gap-2"
        @mouseleave="hover = false"
        @mouseover="hover = true"
    >
        <img
            :alt="name"
            :src="`${page.props.app.cdn_url}/assets/en/outgame/extension/pot_skill_0${skillId}_${
                active || hover ? 'on' : 'off'
            }.png`"
            class="h-12 w-12"
        />

        <span
            :class="percentageClass"
            class="grow text-center text-lg font-semibold"
            >{{ percentage.toFixed() }}%</span
        >
    </div>
</template>

<style scoped></style>
